import './script-editor-page.css';
import { useEffect, useState } from 'react';
import { Button, Modal, notification } from 'antd';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import { addControlStyle } from './script-editor-page-style';
import { useNavigate, useParams } from 'react-router-dom';

import _isUndefined from 'lodash/isUndefined';
import { useLazyGetTransformerScriptQuery, useSaveTransformerScriptMutation } from '../../redux/api/transformers';
import { ScriptTestModal } from './script-test-modal';

const ScriptEditorPage = () => {

    const [ id, setId ] = useState<number | undefined>();
    const [ code, setCode ] = useState<string>('');
    const [ isTestOpen, setTestOpen ] = useState<boolean>(false);
    const [tableHeight, setTableHeight] = useState<number>();
    
    const { clientId } = useParams();

    const [getScript] = useLazyGetTransformerScriptQuery();
    const [saveScript] = useSaveTransformerScriptMutation();
    
    const navigate = useNavigate();

    const updateTableHeight = () => {
        const windowHeight = window.innerHeight; // Full screen height
        const calculatedHeight = windowHeight - 168; // Subtract paddings and headers
        setTableHeight(calculatedHeight);
    };
      
    useEffect(() => {
        fetchScript();
        updateTableHeight(); // Set height on mount
        window.addEventListener("resize", updateTableHeight); // Adjust height on resize
        return () => window.removeEventListener("resize", updateTableHeight);
    }, []);

    const fetchScript = async () => {

        try {
          const response = await getScript(clientId).unwrap();
          setId(response.id);
          setCode(response.script);
        } catch (e) {
        }
    }

    const onTest = () => {
        setTestOpen(true);
    }

    /**
     * Adds a user by sending the user data to the server.
     * 
     * @param user the user to add
     */
    const onSave = async (): Promise<void> => {

        try {

            const script = {
              id: id,
              client: {
                id: clientId,
              },
              script: code,
            }
            await saveScript(script);
            
        } catch (e) {
            console.log(e);
            notification.error({
              message: "Creating User Failed!",
              description: `An error occurred while creating the user`
            });
        }
    }

    return <>
        <div style={addControlStyle}>
            <h1>Transformer Script</h1>
            <div className="controls">
            <Button
                type="primary"
                onClick={onTest}>
                Test Script
            </Button>
            <Button
                type="primary"
                onClick={onSave}>
                Save Script
            </Button>
            </div>
        </div>
        <div className="editor" style={{height: tableHeight}}>
            <Editor
                value={code}
                onValueChange={code => setCode(code)}
                highlight={(code) => highlight(code, languages.js!, 'js')}
                padding={10}
                style={{
                    minHeight: tableHeight,
                    background: 'white',
                    border: 'none',
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 14,
                }}
            />
        </div>

        <ScriptTestModal
            clientId={parseInt(clientId!)}
            open={isTestOpen}
            onCancel={() => setTestOpen(false)}/>
    </>
};

export default ScriptEditorPage;

